import * as angular from "angular";

import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.shippers')
  .factory('$shipper', ShipperObjectFactory);

/* @ngInject */
function ShipperObjectFactory($bringozFactory: $bringozFactory,
                              ShippersAPI: BringozApi,
                              Shippers_DS: DataStoreConfig,
                              Shippers_PN: PushNotificationsConfig) {

  function $shipper(id: string) {
    return $bringozFactory(id, ShippersAPI, Shippers_DS, Shippers_PN);
  }

  return $shipper;
}
